/**
 * Finance Dashboard Service
 * 
 * Serviço para buscar dados do dashboard financeiro.
 */

import api from './api'

export const financeDashboardService = {
  /**
   * Buscar dados do dashboard principal
   * @param {Object} filters - Filtros opcionais (month, year, financialAccountId)
   * @returns {Promise} Dados do dashboard
   */
  getDashboardData: async (filters = {}) => {
    try {
      const response = await api.get('/api/financial/dashboard', { params: filters })
      return response.data
    } catch (error) {
      console.error('Erro ao buscar dados do dashboard:', error)
      throw error
    }
  },

  /**
   * Buscar dados da análise profunda
   * @param {Object} filters - Filtros opcionais (month, year, period)
   * @returns {Promise} Dados de análise
   */
  getAnalysisData: async (filters = {}) => {
    try {
      const response = await api.get('/api/financial/dashboard/analysis', { params: filters })
      return response.data
    } catch (error) {
      console.error('Erro ao buscar dados de análise:', error)
      throw error
    }
  },

  /**
   * Buscar projeção de fechamento do mês
   * @param {Number} month - Mês (1-12)
   * @param {Number} year - Ano
   * @returns {Promise} Dados de projeção
   */
  getMonthEndProjection: async (month, year) => {
    try {
      const response = await api.get('/api/financial/dashboard/projection', {
        params: { month, year }
      })
      return response.data
    } catch (error) {
      console.error('Erro ao buscar projeção:', error)
      throw error
    }
  }
}
